import { service, model } from 'eco-cli'
import { Menu, MenuTree, InValue, LabelFile, Article } from '@/models/index.js'
import { VipArticle } from '@/models/Article'
const { finance, system } = service;

export const getTypeList = () =>
    system.get("/system/dict/select/options/freeBackType", null);

export const sendFeedback = (obj) =>
    finance.withToken.post("feedback/createOrUpdate", obj)


//   {
// 	"contact": "",
// 	"content": "",
// 	"ftype": "",
// 	"id": "",
// 	"vipId": ""
// }